var _defs, _circle, _path, _path2, _circle2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotonesSvg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2503.45 1222.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d91111;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-3, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        filter: url(#drop-shadow-32);\n      }\n\n      .cls-4 {\n        fill: #a81414;\n      }\n\n      .cls-5 {\n        filter: url(#drop-shadow-31);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-31",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#26130a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-32",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#26130a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 606.33,
    cy: 611.08,
    r: 525.8,
    transform: "translate(-254.51 607.72) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2196.05,341.64H728.6v545.98h1467.45c125.29,0,226.86-101.57,226.86-226.86v-92.26c0-125.29-101.57-226.86-226.86-226.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m2228.57,384.68H802.21v459.89h1426.37c80.26,0,145.55-103.15,145.55-229.94s-65.3-229.94-145.55-229.94Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 606.33,
    cy: 611.08,
    r: 387.04
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1313.57,464.41h31.99c11.12,0,19.24,2.59,24.34,7.75,5.1,5.17,7.66,13.12,7.66,23.85v8.44c0,14.26-4.71,23.29-14.13,27.09v.39c5.23,1.57,8.93,4.78,11.09,9.62,2.16,4.84,3.24,11.32,3.24,19.43v24.14c0,3.93.13,7.1.39,9.52.26,2.42.91,4.81,1.96,7.16h-21.98c-.79-2.22-1.31-4.32-1.57-6.28-.26-1.96-.39-5.5-.39-10.6v-25.12c0-6.28-1.02-10.66-3.04-13.15-2.03-2.48-5.53-3.73-10.5-3.73h-7.46v58.89h-21.59v-137.4Zm29.44,58.89c4.32,0,7.56-1.11,9.71-3.34,2.16-2.22,3.24-5.95,3.24-11.19v-10.6c0-4.97-.88-8.57-2.65-10.8-1.77-2.22-4.55-3.34-8.34-3.34h-9.81v39.26h7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1412.3,464.41h58.89v19.63h-37.29v36.31h29.64v19.63h-29.64v42.2h37.29v19.63h-58.89v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1503.18,464.41h31.8c10.73,0,18.78,2.88,24.14,8.64,5.37,5.76,8.05,14.2,8.05,25.32v13.54c0,11.12-2.68,19.56-8.05,25.32-5.37,5.76-13.41,8.64-24.14,8.64h-10.21v55.94h-21.59v-137.4Zm31.8,61.83c3.53,0,6.18-.98,7.95-2.94,1.77-1.96,2.65-5.3,2.65-10.01v-16.29c0-4.71-.88-8.05-2.65-10.01-1.77-1.96-4.42-2.94-7.95-2.94h-10.21v42.2h10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1605.45,594.75c-5.63-6.02-8.44-14.53-8.44-25.52v-72.23c0-10.99,2.81-19.5,8.44-25.52,5.62-6.02,13.74-9.03,24.34-9.03s18.71,3.01,24.34,9.03c5.62,6.02,8.44,14.53,8.44,25.52v72.23c0,10.99-2.81,19.5-8.44,25.52-5.63,6.02-13.74,9.03-24.34,9.03s-18.71-3.01-24.34-9.03Zm35.53-24.14v-74.98c0-9.03-3.73-13.54-11.19-13.54s-11.19,4.51-11.19,13.54v74.98c0,9.03,3.73,13.54,11.19,13.54s11.19-4.51,11.19-13.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1696.72,464.41h31.99c11.12,0,19.24,2.59,24.34,7.75,5.1,5.17,7.66,13.12,7.66,23.85v8.44c0,14.26-4.71,23.29-14.13,27.09v.39c5.23,1.57,8.93,4.78,11.09,9.62,2.16,4.84,3.24,11.32,3.24,19.43v24.14c0,3.93.13,7.1.39,9.52.26,2.42.91,4.81,1.96,7.16h-21.98c-.79-2.22-1.31-4.32-1.57-6.28-.26-1.96-.39-5.5-.39-10.6v-25.12c0-6.28-1.02-10.66-3.04-13.15-2.03-2.48-5.53-3.73-10.5-3.73h-7.46v58.89h-21.59v-137.4Zm29.44,58.89c4.32,0,7.56-1.11,9.71-3.34,2.16-2.22,3.24-5.95,3.24-11.19v-10.6c0-4.97-.88-8.57-2.65-10.8-1.77-2.22-4.55-3.34-8.34-3.34h-9.81v39.26h7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1811.94,484.04h-22.57v-19.63h66.74v19.63h-22.57v117.77h-21.59v-117.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1886.14,464.41h58.89v19.63h-37.29v36.31h29.64v19.63h-29.64v42.2h37.29v19.63h-58.89v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1319.07,766.6c-5.5-5.95-8.24-14.49-8.24-25.62v-72.23c0-11.12,2.75-19.66,8.24-25.62,5.5-5.95,13.48-8.93,23.95-8.93s18.45,2.98,23.95,8.93c5.5,5.96,8.24,14.5,8.24,25.62v11.78h-20.41v-13.15c0-9.03-3.73-13.54-11.19-13.54s-11.19,4.51-11.19,13.54v75.18c0,8.9,3.73,13.35,11.19,13.35s11.19-4.45,11.19-13.35v-26.89h-10.79v-19.63h31.21v44.95c0,11.12-2.75,19.66-8.24,25.62-5.5,5.96-13.48,8.93-23.95,8.93s-18.45-2.98-23.95-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1408.77,636.16h58.89v19.63h-37.29v36.31h29.64v19.63h-29.64v42.2h37.29v19.63h-58.89v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1499.65,636.16h27.09l21,82.25h.39v-82.25h19.24v137.4h-22.18l-25.91-100.3h-.39v100.3h-19.24v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1603.09,636.16h58.89v19.63h-37.29v36.31h29.64v19.63h-29.64v42.2h37.29v19.63h-58.89v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1693.97,636.16h31.99c11.12,0,19.24,2.59,24.34,7.75,5.1,5.17,7.66,13.12,7.66,23.85v8.44c0,14.26-4.71,23.29-14.13,27.09v.39c5.23,1.57,8.93,4.78,11.09,9.62,2.16,4.84,3.24,11.32,3.24,19.43v24.14c0,3.93.13,7.1.39,9.52.26,2.42.91,4.81,1.96,7.16h-21.98c-.79-2.22-1.31-4.32-1.57-6.28-.26-1.96-.39-5.5-.39-10.6v-25.12c0-6.28-1.02-10.66-3.04-13.15-2.03-2.48-5.53-3.73-10.5-3.73h-7.46v58.89h-21.59v-137.4Zm29.44,58.89c4.32,0,7.56-1.11,9.71-3.34,2.16-2.22,3.24-5.95,3.24-11.19v-10.6c0-4.97-.88-8.57-2.65-10.8-1.77-2.22-4.55-3.34-8.34-3.34h-9.81v39.26h7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1809.39,636.16h29.25l22.38,137.4h-21.59l-3.93-27.28v.39h-24.54l-3.93,26.89h-20.02l22.38-137.4Zm23.55,91.86l-9.62-67.92h-.39l-9.42,67.92h19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1891.04,636.16h21.59v117.77h35.53v19.63h-57.12v-137.4Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m713.58,396.58h-214.5c-29.62,0-53.62,24.01-53.62,53.62v107.25h321.75v-107.25c0-29.62-24.01-53.62-53.62-53.62Zm53.62,187.69h-214.5v53.62h214.5v-53.62Zm0,80.44h-214.5v53.62h214.5v-53.62Zm0,80.44h-214.5v80.44h160.88c29.62,0,53.62-24.01,53.62-53.62v-26.81Zm-241.31,80.44v-80.44h-80.44v26.81c0,29.62,24.01,53.62,53.62,53.62h26.81Zm-80.44-107.25h80.44v-53.62h-80.44v53.62Zm0-80.44h80.44v-53.62h-80.44v53.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotonesSvg12);
export default __webpack_public_path__ + "static/media/BOTONES_SVG 12.4393876c8406ab2214520438d38d369c.svg";
export { ForwardRef as ReactComponent };